var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMenuView)?_c('Page',[_c('exception-page',{attrs:{"type":"404","show-home-button":!_vm.isMenuView}})],1):_c('exception-page',{attrs:{"type":"404","show-home-button":!_vm.isMenuView}})
}
var staticRenderFns = []

export { render, staticRenderFns }